const OPCOES = [10, 25, 50, 100];

export default function Paginacao({ pagina, totalPaginas, inicio, fim, total, porPagina, setPagina, setPorPagina }) {
  if (total === 0) return null;

  const pages = [];
  const delta = 2;
  const left = Math.max(2, pagina - delta);
  const right = Math.min(totalPaginas - 1, pagina + delta);

  pages.push(1);
  if (left > 2) pages.push('...');
  for (let i = left; i <= right; i++) pages.push(i);
  if (right < totalPaginas - 1) pages.push('...');
  if (totalPaginas > 1) pages.push(totalPaginas);

  return (
    <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 px-3 py-2 border-top">
      <div className="d-flex align-items-center gap-2 small text-muted">
        <span>Exibindo {inicio}–{fim} de {total}</span>
        <span className="text-muted">|</span>
        <span>Por página:</span>
        <select
          className="form-select form-select-sm"
          style={{ width: 70 }}
          value={porPagina}
          onChange={e => setPorPagina(Number(e.target.value))}
        >
          {OPCOES.map(o => <option key={o} value={o}>{o}</option>)}
        </select>
      </div>

      {totalPaginas > 1 && (
        <nav>
          <ul className="pagination pagination-sm mb-0">
            <li className={`page-item ${pagina === 1 ? 'disabled' : ''}`}>
              <button className="page-link" onClick={() => setPagina(pagina - 1)}>‹</button>
            </li>
            {pages.map((p, i) =>
              p === '...'
                ? <li key={`e${i}`} className="page-item disabled"><span className="page-link">…</span></li>
                : <li key={p} className={`page-item ${p === pagina ? 'active' : ''}`}>
                    <button
                      className="page-link"
                      style={p === pagina ? { background: 'var(--main-color)', borderColor: 'var(--main-color)' } : {}}
                      onClick={() => setPagina(p)}
                    >{p}</button>
                  </li>
            )}
            <li className={`page-item ${pagina === totalPaginas ? 'disabled' : ''}`}>
              <button className="page-link" onClick={() => setPagina(pagina + 1)}>›</button>
            </li>
          </ul>
        </nav>
      )}
    </div>
  );
}
